import { Component, OnInit, Inject, LOCALE_ID, ChangeDetectorRef, AfterViewChecked, ViewChild, ElementRef, NgZone   } from '@angular/core';
import { BackendService } from '../services/backend.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Dealer, GetResellersResultCode, GetResellersResult, CustomerInfo, Position, FilterType } from '../models';
import { DataStorageService } from '../services/data-storage.service';
import { Router, ActivatedRoute, NavigationEnd, Routes, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SentWishlistDialogComponent } from '../dialogs/sent-wishlist-dialog/sent-wishlist-dialog';
import { RecaptchaTokenService } from '../services/recaptcha-token.service';
import { InsertCaptchaDialogComponent } from '../dialogs/insert-captcha-dialog/insert-captcha-dialog';
import { IncorrectCaptchaDialogComponent } from '../dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog';
import { IncorrectCountryDialogComponent } from '../dialogs/incorrect-country-dialog/incorrect-country-dialog';
import { LimitErrorDialogComponent } from '../dialogs/limit-error-dialog/limit-error-dialog';
import { NotFoundDialogComponent } from '../dialogs/not-found-dialog/not-found-dialog';
import { GenericErrorDialogComponent } from '../dialogs/generic-error-dialog/generic-error-dialog';
import { forEach } from '@angular/router/src/utils/collection';
import { GoogleMap, LatLngBounds } from '@agm/core/services/google-maps-types';
import { GoogleMapsAPIWrapper, LatLng } from '@agm/core';
import { GoogleMapsService } from '../services/google-maps.service';
import { ConfigurationService } from '../services/configuration.service';
import { OverQueryLimitDialogComponent } from '../dialogs/over-query-limit-dialog/over-query-limit-dialog';
import { NoResellersFoundDialogComponent } from '../dialogs/no-resellers-found-dialog/no-resellers-found-dialog';
import { LocalizationService } from '../services/localization.service';
import { filter, map, mergeMap } from 'rxjs/operators';
import { MapsAPILoader } from '@agm/core';
import { Address } from 'ngx-google-places-autocomplete/objects/address';

@Component({
    selector: 'app-where-to-buy',
    templateUrl: './where-to-buy.component.html',
    styleUrls: ['./where-to-buy.component.css']
})
export class WhereToBuyComponent implements OnInit, AfterViewChecked {

  @ViewChild('contentContainer') contentContainerRef: ElementRef;

    private lastSentHeight: number = 0;



    isMobile: boolean;

    public IW: any;

    public selectedAddress: string = "";
    public formattedAddress: string = "";

    public mainForm: FormGroup;
    public customers: Dealer[];

    public centerLat: number = null;
    public centerLng: number = null;

    public hasWishList = false;
    public isLoading = false;
    public needCaptcha = false;
    public needAddress = false;
    public onlyRsc55 = false;
    public onlyWorkwear = false;
    public check_Rsc = false;
    public isApiLoaded: boolean = false;
    public showCheckboxes: boolean = true;
    private specialKeys: Array<string> = [ "magics", "supermagics", "superreset", "hypermagics" ];

    constructor(
        private backend: BackendService,
        private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        @Inject(LOCALE_ID) locale: string,
        private dialog: MatDialog,
        private dataStorageService: DataStorageService,
        private cd: ChangeDetectorRef,
        private recaptchaTokenService: RecaptchaTokenService,
        private googleMapsService: GoogleMapsService,
        private configurationService: ConfigurationService,
        public loc: LocalizationService,
        private ngZone: NgZone,  
        private mapsAPILoader: MapsAPILoader) {

        //this.loc = localization;
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.rootRoute(this.route)),
            filter((route: ActivatedRoute) => route.outlet === 'primary'),
            mergeMap((route: ActivatedRoute) => route.data)
          ).subscribe((event: {[name: string]: any}) =>
          {
            console.log("Route changed, new language: " + event['language']);
            this.loc.setLang(event['language']);
          });

        this.mainForm = this.fb.group({
            address: ['', [
                Validators.required,
            ]]/*,
            onlyRsc55: [false, [
                Validators.required
            ]],
            onlyWorkwear: [false, [
                Validators.required
            ]],*/
        });
    }

    private rootRoute(route: ActivatedRoute): ActivatedRoute {
      while (route.firstChild) {
        route = route.firstChild;
      }
      return route;
    }

    ngOnInit() {

      this.mapsAPILoader.load().then(() =>{
        this.isApiLoaded = true;
      });

        const lang: string = this.loc.currLang();
        const configuration = this.dataStorageService.getConfiguration();
        const refresh = this.dataStorageService.isRefresh();
        this.onlyRsc55 = this.dataStorageService.isOnlyRsc55();
        this.onlyWorkwear = this.dataStorageService.isOnlyWorkwear();

        // Se non c'è una configurazione salvata nello storage
        if (configuration == null || refresh) {

            //console.log("no config or refresh " + (configuration == null) + " " + refresh);
            // La chiede al server
            this.configurationService.GetConfiguration().subscribe(res => {

                // Se non c'è salvato niente sul server (arriviamo dal sito e non dalla wishlist)
                if (res == null) {

                    //console.log("Salviamo una configurazione vuota");
                    // Salviamo una configurazione "vuota"
                    this.dataStorageService.setConfiguration({
                        isMobile: false,
                        wishList: null,
                        isCassettiera: false
                    });
                } else {

                    // Prendiamo le info che ci servono
                    this.isMobile = res.isMobile;
                    this.hasWishList = res.wishList !== null && res.wishList.length > 0;

                    // Salviamo la configurazione arrivata dal server
                    this.dataStorageService.setConfiguration(res);
                }

            });

        } else {
            // Prendiamo le info che ci servono
            this.isMobile = configuration.isMobile;
            this.hasWishList = configuration.wishList !== null && configuration.wishList.length > 0;
        }

        this.showCheckboxes = (lang == "IT");

        //DEBUG 
        //this.hasWishList = true; //simulo la presenza di una whishlist per scatenare il meccanismo di invio DEBUG DEBUG

        this.customers = this.dataStorageService.getDealersList();

        setTimeout(() => {

            if (this.customers != null && this.customers.length > 0) {
                this.fixBoundsAndZoom();
            } else {

                const wrapper = this.googleMapsService.getWrapper();
                let zoomLevel = 5;
                let center: any = { lat: 45, lng: 9 };  // IT
                if (lang == "ES") {
                    center = { lat: 40, lng: -3 };        // ES
                    zoomLevel = 6;
                }
                if (lang == "HU") {                     
                    center = { lat: 47, lng: 19 };      // HU
                    zoomLevel = 7;
                }
                if (lang == "NL") {                     
                    center = { lat: 51.3, lng: 5.2 };      // NL
                    zoomLevel = 6;
                }
                if (lang == "FR") {                     
                    center = { lat: 47.2, lng: 2.5 };      // FR
                    zoomLevel = 5;
                }
                if (lang == "UK") {                     
                    center = { lat: 54.2, lng: -2.9 };      // UK
                    zoomLevel = 6;
                }
                if (lang == "DE") {                     
                    center = { lat: 50.2, lng: 10.4 };      // DE
                    zoomLevel = 5;
                }
                if (lang == "AT") {                     
                    center = { lat: 47.3, lng: 13.3 };      // AT
                    zoomLevel = 6;
                }
                //ToDo aggiungere nuova filiale il centromappa e lo zoom
            
                console.log("W2b onInit lang = " + lang );
                console.log("W2b onInit center = " + JSON.stringify(center) );
                console.log("W2b onInit zoomLevel = " + zoomLevel );    

                this.googleMapsService.getWrapper().setCenter(center);
                this.googleMapsService.getWrapper().setZoom(zoomLevel);
            }
        }, 3000);
    }

    handleAddressChange(address: Address)
    {
      this.formattedAddress = address.formatted_address;
      this.selectedAddress = this.mainForm.get("address").value;
    }

    checkAddress(address: string)
    {
      if (!this.specialKeys.includes(address) &&
           this.selectedAddress != address)
      {
        this.formattedAddress = "";
        this.selectedAddress = "";
      }
    }

    canSubmit(): boolean
    {
      let val = this.mainForm.get("address").value;
      return this.selectedAddress != '' || this.specialKeys.includes(val);
    }

    exclusive(ctrl: string, value: boolean) {
        if (value) {
            let obj = {};
            obj[ctrl] = false;
            this.mainForm.patchValue(obj);
        }
    }

    fixBoundsAndZoom(center: Position = null) {

        const google = (<any>window).google;

        if (google == null || google.maps == null) { return; }

        const wrapper = this.googleMapsService.getWrapper();

        const bounds = new google.maps.LatLngBounds();

        for (const cust of this.customers) {
            bounds.extend(new google.maps.LatLng(cust.lat, cust.lng));
        }

        if (center != null) {
            bounds.extend(new google.maps.LatLng(center.lat, center.lng));
        }

        wrapper.fitBounds(bounds);

    }

    // Fix dealer website
    fixCustomers(dealers: Dealer[]): Dealer[] {
        for (const dealer of dealers) {

            dealer.isOpen = false;
            if (dealer.webSite == null) { continue; }
            const website = dealer.webSite.toLowerCase();

            if (!website.startsWith('http'))
            {
                dealer.webSite = 'https://' + website;
            }
        }
        return dealers;
    }

    private searchAddress(captcha: string = null) {

        this.isLoading = true;

        let address: string = this.formattedAddress;
        const txt = this.mainForm.get('address').value;
        if (this.specialKeys.includes(txt))
          address = txt;

        const onlyRsc55 = this.check_Rsc || this.onlyRsc55;
        const onlyWorkwear = /*this.mainForm.get('onlyWorkwear').value ||*/ this.onlyWorkwear;

        const filter = onlyRsc55 ? FilterType.OnlyRsc55 : (onlyWorkwear ? FilterType.OnlyWorkwear : FilterType.None);

        this.backend.GetResellers(address, filter, captcha).subscribe(res => {

            if(res === null) {
                console.log("Null res from GetResellers");
                this.isLoading = false;
            }
            else {
                switch (res.result) {
                    case GetResellersResultCode.Ok:

                        const fixedCustomers = this.fixCustomers(res.customers);

                        this.customers = fixedCustomers;

                        this.centerLat = res.position.lat;
                        this.centerLng = res.position.lng;

                        this.needAddress = false;
                        this.needCaptcha = false;

                        this.dataStorageService.setDealersList(fixedCustomers);

                        if (this.customers.length === 0) {
                            this.dialog.open(NoResellersFoundDialogComponent, {
                                width: '300px'
                            });
                            const wrapper = this.googleMapsService.getWrapper();
                            wrapper.setZoom(4);
                        } else {
                            this.fixBoundsAndZoom(res.position);
                        }

                        break;

                    case GetResellersResultCode.NeedAddress:

                        this.needAddress = true;

                        break;

                    case GetResellersResultCode.NeedCaptcha:

                        this.dialog.open(InsertCaptchaDialogComponent, {
                            width: '300px'
                        }).afterClosed().subscribe(ca => {
                            if (ca == null || ca === '') { return; }
                            this.searchAddress(ca);
                        });

                        break;

                    case GetResellersResultCode.RequestLimitReached:

                        this.dialog.open(LimitErrorDialogComponent, {
                            width: '300px'
                        });

                        break;


                    case GetResellersResultCode.OverQueryLimit:

                        this.dialog.open(OverQueryLimitDialogComponent, {
                            width: '300px'
                        });

                        break;

                    case GetResellersResultCode.NotFound:

                        this.dialog.open(NotFoundDialogComponent, {
                            width: '300px'
                        });

                        break;

                    case GetResellersResultCode.FailedCaptcha:

                        this.dialog.open(IncorrectCaptchaDialogComponent, {
                            width: '300px'
                        });

                        break;

                    case GetResellersResultCode.Error:

                        this.dialog.open(GenericErrorDialogComponent, {
                            width: '300px'
                        });

                        break;

                    case GetResellersResultCode.NotFoundInCountry:

                        this.dialog.open(IncorrectCountryDialogComponent, {
                            width: '300px'
                        });

                        break;
                }
                this.isLoading = false;
            }
        }, err => {
            console.log(err);
            this.isLoading = false;

        });
    }

    goToDealer(dealer: Dealer) {
        // [routerLink]="['send-wish-list-to-dealer', customer.mail]"

        this.dataStorageService.setDealer(dealer);
        this.router.navigate([this.loc.currLang(), 'send-wish-list-to-dealer']);
    }

    onSubmit() {

        this.searchAddress();

    }


    public closeAllOthers(data: any, customer: Dealer) {
        if (this.IW) {
            this.IW.close();
        }

        this.IW = data;

        customer.isOpen = true;
        /*for (let n = 0; n < this.customers.length; n++) {
            const curr = this.customers[n];
            if (curr.name !== customer.name) {
                curr.isOpen = false;
            }
        }*/
    }

    public setCenter(customer: Dealer, updateCoords: boolean = true) {

        if (updateCoords) {
            // this.lat = customer.lat;
            // this.lng = customer.lng;
        }
        if(customer.isOpen ) {
            customer.isOpen = false;
        }
        else {
            customer.isOpen = true;

            // console.log(customer);

            for (const ct of this.customers) {
                if (ct.name === customer.name) { continue; }
                ct.isOpen = false;

            }
        }
        this.cd.detectChanges();

    }

    public onCloseInfo(customer) {
        customer.isOpen = false;
    }

    public onToggleRSC() {
        this.check_Rsc = !this.check_Rsc;
    }

    @ViewChild('col_elenco') elElenco: ElementRef;
    @ViewChild('col_mappa') elMappa: ElementRef;

    ngAfterViewChecked() {
        /*if (this.elElenco && this.elMappa) {
            console.log(this.elMappa.nativeElement.offsetHeight + 'px');
            this.elElenco.nativeElement.style.height = this.elMappa.nativeElement.offsetHeight + 'px';

        }*/
        if (this.contentContainerRef) {
          const currentHeight = this.contentContainerRef.nativeElement.offsetHeight;
      
          // Controllo per inviare il messaggio solo se l'altezza è cambiata
          if (currentHeight > 0 && currentHeight !== this.lastSentHeight) {
              // Usa NgZone.run() per uscire dalla change detection e inviare
              // Il postMessage non deve innescare un nuovo ciclo di CD.
              this.ngZone.runOutsideAngular(() => {
                  window.parent.postMessage({ 'frameHeight': (currentHeight/* + 120/*aggiungo il padding:60 */) }, '*');
              });
              console.log('w2b inviata al parent: ' + currentHeight);
              this.lastSentHeight = currentHeight;
          }
      }
    }


}

export class LatLngImpl implements LatLng {
    private _lat: number;
    private _lng: number;
    lat() {
        return this._lat;
    }
    lng() {
        return this._lng;
    }
    // here's the important part
    ['constructor'](lat: number, lng: number): void
    {
      this._lat = lat;
      this._lng = lng;
    }
}



// WEBPACK FOOTER //
// ./src/app/where-to-buy/where-to-buy.component.ts